// extracted by mini-css-extract-plugin
export default {"overlay":"Overlay_overlay__vbcml","main":"Overlay_main__4PSzW"};